import { APP_BAR_ID } from "@utils/settings";

export const handleFixedTableHeader = (el, container, offset=0, modifier=0) => {
  if(!el || !container) return;
  const border = Math.floor(
    document.getElementById(APP_BAR_ID)?.getBoundingClientRect()?.height || 0
  ) + offset;
  const anchorTop = Math.floor(container.getBoundingClientRect().top);
  const anchorBottom = anchorTop + container.offsetHeight - el.offsetHeight;
  
  if (anchorTop <= border && anchorBottom > border) {
    el.style.transform = `translateY(${-anchorTop + border + modifier}px)`;
    el.style.boxShadow = "rgba(0, 0, 0, 0.14) 0px 4px 5px 0px";
  } else if (el.style.transform) {
    el.style.transform = null;
    el.style.boxShadow = null;
  }
};
